import { Modal, Table } from "react-bootstrap";
import Nodata from "../component/common-component/Nodata";

const PrivacyPolicyViewModal = ({ privacyPolicy, showModal, closeModel }) => {
  return (
    <Modal
      show={showModal}
      onHide={closeModel}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable
      backdrop="static"
      className="terms-height"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Privacy & Policy
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {privacyPolicy ? (
          <p
            dangerouslySetInnerHTML={{
              __html: privacyPolicy,
            }}
          />
        ) : (
          <Nodata />
        )}
      </Modal.Body>

      {/* <Modal.Footer>
        <button className="grey-btn w-auto" onClick={closeModal}>
          Cancel
        </button>
         
      </Modal.Footer> */}
    </Modal>
  );
};

export default PrivacyPolicyViewModal;
